export enum PointType {
  text = <any>'text',
  image = <any>'image',
  movie = <any>'movie',
  sound = <any>'sound',
  embed = <any>'embed',
  chart = <any>'chart'
}
